module.exports = __webpack_public_path__ + "static/img/mine_bg.1a7a3c95.png";